import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, Row, Col, message } from "antd";

const CustomerForm = ({ open, setOpen, initialValue, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [pinCode, setPinCode] = useState('')
  useEffect(() => {
    if (open) {
      if (isEdit && initialValue) {
        // Set form values when in edit mode and initialValue is provided
        form.setFieldsValue({
          ...initialValue,
          address: {
            street: initialValue.address?.street || "",
            city: initialValue.address?.city || "",
            state: initialValue.address?.state || "",
            pincode: initialValue.address?.pincode || "",
          },
        });
        // Set latitude and longitude in edit mode if available
      } else {
        // Reset the form when not in edit mode
        form.resetFields();
      }
    }
  }, [isEdit, initialValue, open, form]);


  async function getCityState(pincode) {
    const response = await fetch(`https://api.postalpincode.in/pincode/${pincode}`);
    const data = await response.json();

    if (data[0].Status === "Success") {
      const postOffice = data[0].PostOffice[0];
      form.setFieldsValue({
        address: {
          city: postOffice?.District || "",
          state: postOffice?.State || "",
        },
      });
    } else {
      form.setFieldsValue({
        address: {
          city: null,
          state: null,
        },
      });
      message.error("PinCode not found")
    }
  }

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const { address, ...rest } = values;
      const payload = {
        ...rest,
        address: {
          street: address?.street,
          city: address?.city,
          state: address?.state,
          pincode: address?.pincode,
        },
      };
      await onSubmit(payload);
    } catch (error) {
      console.error("Submit failed:", error);
      message.error(error.response?.data?.message || "Submit failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Customer" : "Add Customer"}
      width={500}
      onClose={() => setOpen(false)}
      open={open}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Please enter the name!" }]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            // { required: true, message: "Please enter the email!" },
            { type: "email", message: "Please enter a valid email!" },
          ]}
        >
          <Input placeholder="Enter your email address" disabled={isEdit} />
        </Form.Item>

        <Form.Item
          name="phone"
          label="Phone"
          rules={[{ required: true, message: "Please enter the phone number!" }]}
        >
          <Input placeholder="Enter your phone number" />
        </Form.Item>
        <Form.Item
          label="GST Number"
          name="gstNumber"
          rules={[
            {
              pattern: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/,
              message: "Please enter a valid GST number!",
            },
          ]}
        >
          <Input placeholder="GST Number" />
        </Form.Item>
        <Form.Item label="Address">
          <Form.Item
            label="Street"
            name={["address", "street"]}
            // rules={[{ required: true, message: "Please enter the street!" }]}
            style={{ marginBottom: 8 }}
          >
            <Input placeholder="Enter your street address" />
          </Form.Item>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label="City"
                name={["address", "city"]}
                // rules={[{ required: true, message: "Please enter the city!" }]}
                style={{ marginBottom: 8 }}
              >
                <Input placeholder="City will autofill based on pincode" disabled />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="State"
                name={["address", "state"]}
                // rules={[{ required: true, message: "Please enter the state!" }]}
                style={{ marginBottom: 8 }}
              >
                <Input placeholder="State will autofill based on pincode" disabled />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="PinCode"
            name={["address", "pincode"]}
            rules={[
              // { required: true, message: "Please enter a pincode!" },
              { pattern: /^[0-9]{6}$/, message: "Pincode must be a 6-digit number!" },
            ]}
          >
            <Input
              placeholder="Enter your pincode"
              type="text"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d{6}$/.test(value)) {
                  getCityState(value); // Call function only if it's 6 digits
                }
              }}
            />
          </Form.Item>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            Save
          </Button>
        </Form.Item>
      </Form>

    </Drawer>
  );
};

export default CustomerForm;
